export const TELEGRAM_LINKS = {
  support: 'https://t.me/mifrain',
  channel: 'https://t.me/MifVPN',
  bot: 'https://t.me/MifVPNbot',
  miniApp: 'https://t.me/mifvpnbot?startapp=1',
};

export function openExternalLink(url: string) {
  window.open(url, '_blank', 'noopener,noreferrer');
}
